import {axios as http} from "@/plugins/http"

export default class Api {
    static categories(query = {}) {
        return http.get("/api/v1/catalog/list", {
            params: query,
        }).then((resp) => {
            return resp.data["items"]
        })
    }
}
